var map = {
	".": 3260,
	"./": 3260,
	"./imgs/tx01.jpg": 7490,
	"./imgs/tx02.jpg": 6014,
	"./imgs/tx03.jpg": 9886,
	"./imgs/tx04.jpg": 3582,
	"./imgs/tx05.jpg": 7533,
	"./imgs/tx06.jpg": 1007,
	"./imgs/tx07.jpg": 1538,
	"./imgs/tx08.jpg": 3730,
	"./imgs/tx09.jpg": 1928,
	"./imgs/tx10.jpg": 1646,
	"./imgs/zan.png": 105,
	"./index": 3260,
	"./index.tsx": 3260,
	"./style.scss": 1778
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7850;